import { useRouter } from "next/router";
import { PencilIcon } from "icons/outline";
import { useMemo } from "react";

import Table from "../../components/Table";
import PaymentLinkStatusBadge from "../../components/PaymentLinkForm/PaymentLinkStatusBadge";
import SuccessPaymentLinkAlert from "../../components/PaymentLinkForm/SuccessPaymentLinkAlert";
import { IconButton, Link } from "ui";
import Layout from "../../components/Layout";
import NextLink from "next/link";

export default function PaymentLinksPage() {
  const router = useRouter();
  const { formMode, url } = router.query;

  const createdSuccessfully = useMemo(() => {
    if (formMode && url) {
      return <SuccessPaymentLinkAlert formMode={formMode} url={url} />;
    }
    return null;
  }, [formMode, url]);

  return (
    <Layout metaTitle="Payment Links">
      <Table
        url="/d/payment_links/"
        formURL="/d/payment_links/form/"
        tableName="payment link"
        tableDescription="Create a payment link with the amount and details you need and share it with your customers anywhere."
        onAddItemClick={() => {
          router.push("/payment-links/add");
        }}
        onEditItemClick={(id) => {
          router.push(`/payment-links/edit/${id}`);
        }}
        customRender={{
          status: PaymentLinkStatusBadge,
        }}
        customPreview={{
          Actions: ({ preview }) => {
            const { id, status } = preview;

            if (status !== "PENDING") return null;

            return (
              <IconButton
                variant="secondary"
                className="mr-2"
                size="xs"
                render={<NextLink href={`/payment-links/edit/${id}`} />}
              >
                <PencilIcon aria-hidden="true" />
              </IconButton>
            );
          },
          Content: {
            intent: ({ intent }) => (
              <div className="flex flex-col">
                <span className="text-sm text-foundations-subtle">Intent</span>
                <Link href={`/intents/${intent}`} target="_blank">
                  {intent}
                </Link>
              </div>
            ),
          },
        }}
        itemAddedSuccessfullyMessage={createdSuccessfully}
      />
    </Layout>
  );
}

PaymentLinksPage.parentPath = "/payment-links";
